export enum CustomerType {
  B2C = "b2c",
  B2B = "b2b",
  B2B2C = "b2b2c",
  POEI = "poei",
  B2U = "b2u",
  APPRENTICESHIP = "apprenticeship",
  OTHER = "other",
}
